export const emptyOrStringValidator = value => value === null || value === undefined || typeof value === 'string';



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/validation.js